import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          query {\n            findPeriodSetting\n          }\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n          mutation {\n            createOrUpdatePeriodSetting(\n              content: \"", "\"\n            )\n          }\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __decorate } from "tslib";
import Vue from 'vue';
import gql from 'graphql-tag';
import { Component } from 'vue-property-decorator';
import { SnackType } from '@/interfaces/snack';
import { showErrors, showNotification } from '@/utils/snack';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import AppDialog from '@/components/AppDialog.vue';
import AppTextField from '@/components/AppTextField.vue';
import AppFormItem from '@/components/AppFormItem.vue';
import AppSelector from '@/components/AppSelector.vue';

var SubscriptionCycle = /*#__PURE__*/function (_Vue) {
  _inherits(SubscriptionCycle, _Vue);

  var _super = _createSuper(SubscriptionCycle);

  function SubscriptionCycle() {
    var _this;

    _classCallCheck(this, SubscriptionCycle);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '设置'
    }, {
      text: '征订周期'
    }];
    _this.confirmDialog = false;
    _this.subscriptionCycle = '';
    _this.sYearIdx = -1;
    _this.sHalfYearIdx = -1;
    _this.yearsOptions = [];
    _this.halfYearsOptions = ['上半年', '下半年'];
    return _this;
  }

  _createClass(SubscriptionCycle, [{
    key: "mounted",
    value: function mounted() {
      var date = new Date();
      var year = date.getFullYear();
      this.yearsOptions = Array.from({
        length: 10
      }, function (v, i) {
        return year - i + 5;
      }).map(function (v) {
        return v.toString();
      });
      this.getPeriodSetting();
    }
  }, {
    key: "confirm",
    value: function () {
      var _confirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.$apollo.mutate({
                  mutation: gql(_templateObject(), this.subscriptionCycle)
                });

              case 3:
                result = _context.sent;

                if (!result) {
                  _context.next = 9;
                  break;
                }

                showNotification({
                  msg: '修改成功！',
                  type: SnackType.Success
                });
                this.confirmDialog = false;
                _context.next = 9;
                return this.getPeriodSetting();

              case 9:
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                typedError = _context.t0;
                showErrors(typedError.graphQLErrors);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function confirm() {
        return _confirm.apply(this, arguments);
      }

      return confirm;
    }()
  }, {
    key: "getPeriodSetting",
    value: function () {
      var _getPeriodSetting = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var result, _this$splitSubscripti, year, halfYear, typedError;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.$apollo.query({
                  query: gql(_templateObject2())
                });

              case 3:
                result = _context2.sent;

                if (result) {
                  this.subscriptionCycle = result.data.findPeriodSetting;
                  _this$splitSubscripti = this.splitSubscriptionCycle(this.subscriptionCycle), year = _this$splitSubscripti.year, halfYear = _this$splitSubscripti.halfYear;
                  this.sYearIdx = this.yearsOptions.findIndex(function (item) {
                    return item === year;
                  });
                  this.sHalfYearIdx = this.halfYearsOptions.findIndex(function (item) {
                    return item === halfYear;
                  });
                }

                _context2.next = 11;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                typedError = _context2.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function getPeriodSetting() {
        return _getPeriodSetting.apply(this, arguments);
      }

      return getPeriodSetting;
    }()
  }, {
    key: "submitForm",
    value: function submitForm() {
      if (this.validateForm('form')) {
        this.subscriptionCycle = this.yearsOptions[this.sYearIdx] + '年' + this.halfYearsOptions[this.sHalfYearIdx];
        this.confirmDialog = true;
      }
    }
  }, {
    key: "resetValidation",
    value: function resetValidation(form) {
      this.$refs[form].resetValidation();
    }
  }, {
    key: "validateForm",
    value: function validateForm(form) {
      return this.$refs[form].validate();
    }
  }, {
    key: "splitSubscriptionCycle",
    value: function splitSubscriptionCycle(str) {
      var year = str.slice(0, 4);
      var halfYear = str.slice(5);
      return {
        year: year,
        halfYear: halfYear
      };
    }
  }]);

  return SubscriptionCycle;
}(Vue);

SubscriptionCycle = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppDialog: AppDialog,
    AppTextField: AppTextField,
    AppFormItem: AppFormItem,
    AppSelector: AppSelector
  }
})], SubscriptionCycle);
export default SubscriptionCycle;